import useSWR from 'swr';
import { graphqlFetcher } from "./internals";
/**
 * It takes a GraphQL query, variables, and a url, and returns a SWR response
 * @param {QueryOptions} [options] - The parameters represents an object which contains properties for the Graphql fetcher function
 */
export function useGraphqlQuery(options) {
  const {
    url,
    skip,
    swrConfig,
    onError,
    ...fetcherOptions
  } = options ?? {
    skip: true
  };
  return useSWR(skip ? null : [url, fetcherOptions], async () => graphqlFetcher({
    url,
    onError,
    ...fetcherOptions
  }), swrConfig);
}
//# sourceMappingURL=useGraphqlQuery.js.map